// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"ded792fa","198":"5af96588","572":"9ca87894","703":"52cd238e"}[chunkId] + ".chunk.js";
};